import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import {getCurrentInstance, onMounted, onUnmounted, onUpdated} from "vue";


const __default__ = {
    name: "VueIntersect"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    observer: {}
  },
  setup(__props: any) {

let props = __props;

let connectedNode: HTMLElement;

function disconnect () {
    if (connectedNode) {
        delete (connectedNode as any).intersectObserverConnected;
        props.observer.unobserve(connectedNode);
        connectedNode = null;
    }
}

function connect() {
    let $el = getCurrentInstance().proxy.$el;
    let elm = $el.nextElementSibling;
    if (elm && !(elm as any).intersectObserverConnected) {
        disconnect();
        if (elm.nodeType === 1) {
            (elm as any).intersectObserverConnected = true;
            connectedNode = elm;
            try {
                props.observer.observe(elm);
            } catch (e) {
            }
        }
    }
}

onMounted(() => connect());
onUpdated(() => connect());
onUnmounted(() => disconnect());


return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})